<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">仪器设备维护记录</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1">
          </OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择所属院系" style="width:320px;" @focus="dialogOpen1"
            @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item label="设备状态">
          <el-select v-model="formInline.status" clearable placeholder="请选择">
            <el-option v-for="item in $store.state.whStatus" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备编号">
          <el-input v-model="formInline.serial_no" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="设备名称">
          <el-input v-model="formInline.device_name" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item :label="`所属${$store.state.themeTitle}室`">
          <el-select v-model="formInline.training_room_id" clearable filterable :placeholder="`请选择`">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd()">维护申请</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="handlePrint">打印</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <custom-table ref="table" :data="tableData" border style="width: 100%">
        <custom-table-column prop="device_individual.serial_no" fixed label="设备编号" width="120">
        </custom-table-column>
        <custom-table-column prop="device_name" fixed label="设备名称" min-width="160px">
        </custom-table-column>
        <custom-table-column prop="status_desc" label="设备状态" width="100" >
        </custom-table-column>
        <custom-table-column prop="maintenance_desc" label="维护说明" min-width="200px">
        </custom-table-column>
        <custom-table-column prop="maintenance_date" label="维护时间" width="160px">
        </custom-table-column>
        <custom-table-column prop="created_at" label="申请时间" width="160px">
        </custom-table-column>
        <custom-table-column prop="device_individual.training_room_name" :label="`所属${$store.state.themeTitle}室`" min-width="180px">
        </custom-table-column>
        <custom-table-column prop="device.structure_1" label="所属组织结构" width="180">
        </custom-table-column>
        <custom-table-column prop="device.device_model" label="型号" width="160">
        </custom-table-column>
        <custom-table-column prop="device.specification" label="规格" width="160">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope" >
            <el-button @click="handleEdit(scope.row,['device','device_individual'])" type="text" size="small">编辑</el-button>
            <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
            <el-button @click="handlePrintRow(scope.row)" type="text" size="small">打印</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="606px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="维护设备" prop="new_device_individual_id">
          <el-cascader v-model="ruleForm.new_device_individual_id" filterable ref="cascader" :props="props"
            style="width:432px;" clearable :options="eqs"></el-cascader>
        </el-form-item>
        <el-form-item label="设备状态" prop="status">
          <el-select v-model="ruleForm.status" clearable  placeholder="请选择">
            <el-option v-for="item in $store.state.whStatus"  style="width:432px;" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="维护日期" prop="maintenance_date">
          <el-date-picker type="datetime" placeholder="选择" clearable value-format="yyyy-MM-dd HH:mm:ss" :picker-options="pickerOptions" v-model="ruleForm.maintenance_date" style="width:432px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="维护说明" prop="maintenance_desc">
          <el-input type="textarea" v-model="ruleForm.maintenance_desc" :rows="5" placeholder="请输入"
            style="width:432px;"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type == 'add'"
            @click="submitFormByFun('ruleForm', createMethod)">确认</el-button>
          <el-button type="primary" v-if="type == 'edit'"
            @click="submitFormByFun('ruleForm', updateMethod)">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
    <div style="display: none;">
      <Printt id="printArea" ref="printt" :printData="printData" ></Printt>
    </div>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinValidate } from '@/assets/js/mixin/validate';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinFormatter } from '@/assets/js/mixin/formatter';
import { mixinPrint } from '@/assets/js/mixin/print';

export default {
  name: 'equipmentInto',
  mixins: [mixinList, mixinValidate, mixinOrgan, mixinFormatter,mixinPrint],
  data() {
    return {
      formInline: {
        structure_1: '',
        structure_2: '',
        serial_no: '',
        device_name: '',
        training_room_id: '',
        status: '',
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      props: {
        emitPath: false
      },
      ruleForm: {
        maintenance_date: '',
        maintenance_desc: '',
        new_device_individual_id: '',
        status: '',
      },
      eqs: [],
      rules: {
        new_device_individual_id: [{ required: true, message: '请选择', trigger: 'change' }],
        maintenance_date: [{ required: true, message: '请选择', trigger: 'change' }],
        status: [{ required: true, message: '请选择', trigger: 'change' }],
        maintenance_desc: [{ required: true, message: '请输入', trigger: 'blur' }],
      },
    };
  },
  components: {},
  created() {
    this.$store.dispatch('getTarinMent');
    this.initEqs();
  },
  mounted() {
    // this.getStudentApply()
    // this.getProvince()
  },
  methods: {
    async initEqs() {
      await this.$store.dispatch('getEqs')
      this.eqs = this.$store.state.allEqs.map(item => {
        let children = []
        if (item.individuals && item.individuals.length > 0) {
          children = item.individuals.map(child => {
            return {
              value: child.id,
              label: child.serial_no
            }
          })
        }
        return {
          value: item.id,
          label: item.device_name,
          children
        }
      })
    },
    async deleteMethod() {
      let res = await this.$api.instance.interfaceServer(`api/new_device/maintenance/delete/${this.delid}`, 'delete');
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/new_device/maintenance/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.instance.interfaceServer('api/new_device/maintenance/apply', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);
      let res = await this.$api.instance.interfaceServer(`api/new_device/maintenance/update/${params.id}`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    handleQuery() {
      this.beforeQueryByKey("structure_1", "structure_2")
      this.$refs.pageChild.page = 1;
      this.getList();
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
